import { render, staticRenderFns } from "./ScanFlow.vue?vue&type=template&id=971abf02&"
import script from "./ScanFlow.vue?vue&type=script&lang=js&"
export * from "./ScanFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports